import { useEffect, useState } from 'react';
import { useMounted } from '@wappsto/blanket';
import { useDispatch } from 'react-redux';
import { makeRequest } from '@wappsto/redux';

const cache: Record<string, any> = {};
const useGetImage = (id: string | undefined) => {
  const dispatch = useDispatch();
  const [status, setStatus] = useState<string | undefined>();
  const [image, setImage] = useState<string | undefined>(id ? cache[id]?.image : undefined);
  const isMounted = useMounted();

  useEffect(() => {
    if (id) {
      if (cache[id]) {
        clearTimeout(cache[id].timeout);
        cache[id].timeout = null;
        cache[id].count += 1;
        if (!cache[id].loaded) {
          setStatus('pending');
        }
      } else {
        setStatus('pending');
        const iconPromise = new Promise<string | undefined>((resolve) => {
          const promise = dispatch(
            makeRequest({
              method: 'GET',
              url: `/icon/${id}?type=application`,
              header: {
                'content/type': 'blob',
              },
              dispatchEntities: false,
            }),
          );
          promise
            .then(async (response: any) => {
              if (cache[id]) {
                cache[id].loaded = true;
                if (response.ok && isMounted.current) {
                  let tempImage = await response.rawResponse.blob();
                  tempImage = URL.createObjectURL(tempImage);
                  cache[id].image = tempImage;
                  resolve(tempImage);
                } else {
                  resolve(undefined);
                }
              }
            })
            .catch(() => {
              if (cache[id]) {
                cache[id].loaded = true;
                resolve(undefined);
              }
            });
        });
        cache[id] = {
          promise: iconPromise,
          count: 1,
        };
      }
      cache[id].promise.then((img: string | undefined) => {
        if (isMounted.current) {
          if (img) {
            setStatus('success');
            setImage(img);
          } else {
            setStatus('error');
          }
        }
      });
    }
    return () => {
      if (id && cache[id]) {
        cache[id].count -= 1;
        if (!cache[id].count && !cache[id].timeout) {
          cache[id].timeout = setTimeout(() => {
            URL.revokeObjectURL(cache[id].image);
            delete cache[id];
          }, 100);
        }
      }
    };
  }, [dispatch, id, image, isMounted]);

  return [image, status];
};

export default useGetImage;
